import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { Getter, namespace, Action } from "vuex-class";

import { storeModules } from "../../store";
import { IBaseHistoryParameter } from "../../models/base-history-paramter";
import HistoryStoreTypes from "../../store/history/history-types.store";
import { ApiResponse, IPagination } from "../../models/app-configuration";
import {
    HistoryMapper,
    IHistoryMapper,
    IPropertyHistoryResponseModel,
    IHistoryConfigurations,
    HistoryConfigurations,
    HistoryResponse
} from "../../models/history";
import PropspectsComponent from "./prospects/ProspectComponent.vue";
import RelationsComponent from "./relations/RelationComponent.vue";
import TimeLineComponent from "./timeline";

import { DateHelper } from "../../utils/date-helper";
import { DataHelper } from "../../utils/data-helper";
import { LabelSetting } from "../../i18n/locale-helper";
import lookupTypesStore from "../../store/lookup/lookup-types.store";
import { EVENT_BUS } from "../../common/constants";
import EvenBus from "../../utils/event-bus"
import EventBus from "../../utils/event-bus";

import { HistoryServices } from "../../services/history.services";
import { LOOKUP_TYPE } from "../../store/lookup/lookup-properties.store";
import { IHistoryType } from "../../models/lookup/history-type";
import { IAppointmentTypeListing } from "../../models/agenda";
import { IGenericObject } from "../../models/common";

const HistoryAction = namespace(storeModules.History, Action);
const LookupAction = namespace(storeModules.Lookup, Action);
const LookupGetter = namespace(storeModules.Lookup, Getter);

//refer: https://element.eleme.io/#/zh-CN/component/pagination

@Component({
    template: require("./template.html"),
    components: {
        prospects: PropspectsComponent,
        relations: RelationsComponent,
        timeline: TimeLineComponent
    }
})
class HistoryTimeLineComponent extends Vue {
    dtIsLoading: boolean = true;
    dtFilterSearch: string;
    dtDateRange: any;
    dtFilterType: string;

    dtIncludeUnits: boolean = false;
    dtUnitIds: number[] = null;
    historyMatching: boolean = false;
    candidateId: number = null;
    HistoryType: number = null;
    HistoryTypeInfo: any = [];
    allHistoryTypeInfo: any = [];
    source = {};
    originSource = {};
    matchingMode = "General";
    matchingList = [
        {
            name: "EXCLUDE_MATCHING_MAILING",
            mode: "General",
        },
        {
            name: "ONLY_MATCHING_MAILING",
            mode: "Matching",
        },
        {
            name: "SHOW_ALL",
            mode: "All",
        },
    ];

    // private historyOffsetTop: number;
    // private scrollContainterElm: any = null;
    private historyService = new HistoryServices();

    @Prop({ required: true, type: [Object] })
    value: any;

    @Prop({ required: true, type: [Object] })
    configs: IHistoryConfigurations<any, any>;

    @Prop({ required: true, type: [String] })
    sourceKey: string;

    @Prop({ type: [Object], default: () => null })
    dataSource: any | null;


    @Prop({ default: true, type: [Boolean] })
    allowDefaultContent: boolean;
    @Prop({ default: null, type: [String] })
    content: string;
    @Prop({ default: "Date", type: [String] })
    datetimeKey: string;

    @Prop({ default: false })
    isAgenda: boolean;

    @Prop({ default: null })
    scrollbarOffset: number;

    @Prop({ default: null })
    fixHeight: number;

    @Prop({ default: 20 })
    pageSize: number;

    @Prop({ default: true })
    hasScrollbar: boolean;

    @Prop({ default: 0 })
    module: number;

    @Prop({ default: false, type: Boolean }) isMatching;

    @Prop({ default: 7 })
    pagerCount: number;

    @Prop() scrollContainerId: string;

    @Prop({ default: false }) includeUnits: boolean;

    @Prop({ default: false }) isEditMode: boolean;
    @Prop({ default: false }) isFixedBlock: boolean;

    @Prop({ default: null, type: String })
    context: string;

    @HistoryAction(HistoryStoreTypes.Get.LIST_CHILDREN)
    storeGetListChildren: (payload: {
        param: IBaseHistoryParameter;
        childId: number;
        key: string;
        index: number;
    }) => Promise<any>;

    @LookupAction(lookupTypesStore.Get.LIST_CANDIDATES) getListCandidates: (type) => Promise<any>;
    @LookupGetter(lookupTypesStore.Set.LIST_CANDIDATES) listCandidates;
    @LookupAction private getLookupData: (type: string) => Promise<ApiResponse>;

    @LookupGetter listOfHistoryType: IHistoryType[];
    @LookupGetter listOfTaskTypes: IGenericObject[];

    @LookupAction(lookupTypesStore.Get.LIST_OF_APPOINTMENT_TYPE)
    storeGetListOfTypes: () => Promise<IAppointmentTypeListing[]>;
    @LookupGetter(lookupTypesStore.Get.LIST_OF_APPOINTMENT_TYPE) listOfAppointmentTypes: IAppointmentTypeListing[];
    /**
     *
     */
    constructor() {
        super();
        this.dtFilterType = "all";
        this.dtDateRange = null;
        this.dtFilterSearch = null;
    }

    @Watch("dtIncludeUnits")
    watchIncludeUnits() {
        this.dtUnitIds = null;
        this.fetchData({ ...this.vModel, ...{ PageIndex: 1 } });
    }

    @Watch('historyMatching')
    watchHistoryMatching(newVal, oldVal) {
        this.fetchData({ ...this.vModel, ...{ PageIndex: 1 } });
    }

    @Watch('matchingMode')
    watchMatchingMode(){
        this.fetchData({ ...this.vModel, ...{ PageIndex: 1 } });
    }

    get pageNumbers(): number[] {
        return [5, 10, 20, 50, 100];
    }

    get vModel() {
        return this.value;
    }

    get vMode(): string {
        return this.coConfig.mode || "timeline";
    }

    get lblGlobal() {
        return LabelSetting.Global;
    }

    get lblSetting(): { [key: string]: any } {
        return LabelSetting.Property;
    }

    //timeOutCleanner: any;
    set vModel(value) {
        this.$emit("input", value);
    }

    get coConfig(): IHistoryConfigurations<any, any> {
        return this.configs;
    }

    get coAllowDefaultContent(): boolean {
        return this.allowDefaultContent;
    }
    get allowEdit(): boolean {
        return this.configs.allowEdit;
    }
    get allowDelete(): boolean {
        return this.configs.allowDelete;
    }
    get showPaging(): boolean {
        return this.configs.showPaging;
    }
    get showInfo(): boolean {
        return this.configs.showInfo;
    }

    get localSource() {
        if (this.dataSource === null) {
            return this.source;
        } else return this.dataSource;
    }

    get coSource() {
        if (!this.localSource.listOfItems) return [];
        return this.localSource.listOfItems;
    }
    get pagination(): IPagination {
        return this.localSource.pagination;
    }

    getDateFilter(record: any) {
        return new Date(record[this.datetimeKey]).toDateString();
    }

    get coDateTimeKey(): string {
        return this.datetimeKey;
    }

    get listOfDate(): IHistoryMapper<IPropertyHistoryResponseModel>[] {
        const dates = this.coSource.map(record => this.getDateFilter(record));
        return Array.from(new Set(dates)).map((dateString: any) => {
            const children = this.coSource.filter(item =>
                this.filterCreater(item, dateString)
            );
            return new HistoryMapper(dateString, children);
        });
    }

    get isDisplayAsTimeline() {
        return !this.vModel.Mode || this.vModel.Mode == 'General' || this.vModel.Mode == 'Matching' || this.vModel.Mode == 'All'
    }

    get isPaginationVisible() {
        return this.pagination && this.pagination.total > 0
    }

    get getAllFilter(){
        let arr = this.listOfHistoryType.concat(this.listOfTaskTypes, this.listOfAppointmentTypes);
        const res = this.allHistoryTypeInfo.map((el) => {
            const mappedObject = arr.find(x => x.Id === el.Id);
            if (mappedObject) {
                return mappedObject;
            }
            return el;
        });

        return res;
    }

    get historyInfoSummary () {
        let sum = [];
        let unknown = 0;
        if (this.HistoryTypeInfo && this.HistoryTypeInfo.length > 0) {
            const vm = this as any;
            const notSum = [12, 13, 14, 15, 16, 17, 18, 19];
            this.HistoryTypeInfo.forEach(e => {
                if (notSum.indexOf(e.Id) < 0) {
                    let obj = null;
                    // switch (e.Type) {
                    //     case 0: // agenda
                    //         obj = this.listOfAppointmentTypes.find(x => x.Id === e.Id)
                    //         break;
                    //     case 1: // history
                    //         obj = this.listOfHistoryType.find(x => x.Id === e.Id)
                    //         break;
                    //     case 2: // task
                    //         obj = this.listOfTaskTypes.find(x => x.Id === e.Id)
                    //         break;
                    //     default:
                    //         break;
                    // }
                    obj = this.getAllFilter.find(x => x.Id === e.Id)
                    if (obj) { 
                        sum.push(`${e.Total} ${vm.$td(e)}`)
                    } else { unknown += e.Total }
                }
            });
            
            if (unknown > 0) {
                // sum.push(`${unknown} ${this.$t(this.lblGlobal.unknown)}`)
            }
        }
        return sum.join(", ").toLowerCase();
    }

    selectedPageSize: number = 20;

    filterCreater(record, pattern: string) {
        return new Date(record[this.datetimeKey]).toDateString() === pattern;
    }

    mounted() {
        this.$watch(
            "vModel",
            (val, oldVal) => {
                this.selectedPageSize = this.vModel.PageSize;
                if (val.Mode == HistoryConfigurations.TYPE_PROPERTY_RELATIONS) {
                    this.dtFilterType = "all";
                }

                if (val.Mode !== oldVal || val.Module !== oldVal.Module) {
                    this.fetchData({ ...val, ...{ PageIndex: 1 } });
                } else {
                    this.fetchData();
                }
            },
            { deep: true }
        );

        this.getListCandidates("Candidate");
        this.storeGetListOfTypes();
        
        const lookupTypes = [
            LOOKUP_TYPE.HistoryType,
            LOOKUP_TYPE.TaskType,
        ].join(',');

        this.getLookupData(lookupTypes);

        this.fetchData();
        EvenBus.$on(EVENT_BUS.HISTORY.UPDATE_HISTORY_LIST, () => {
            this.fetchData();
        })
        EvenBus.$on(EVENT_BUS.HISTORY.REFRESH_HISTORY_UPDATE_DOCUMENT, (context) => {
            this.updateListHistories(context);
        })

        // this.$nextTick(() => {
        //     this.historyOffsetTop = document.getElementById('historty-section-topfilter').offsetTop;
        //     this.scrollContainterElm = document.getElementById(this.scrollContainerId);
        // })
    }

    updateListHistories(context) {
        if (this.context && this.context === context) {
            this.fetchData();
        }
    }

    _fetchDataTimeout = null;
    fetchData(vM?: any) {
        let param = vM || this.vModel;
        if (!param.Id) return;
        clearTimeout(this._fetchDataTimeout);
        // scollTo top history
        // if (this.scrollContainterElm) {
        //     this.scrollContainterElm.scrollTo({
        //         top: this.historyOffsetTop,
        //         behavior: 'smooth'
        //     })
        // }

        let typeInfo = this.allHistoryTypeInfo.find(element => element.Id == this.HistoryType);

        this._fetchDataTimeout = setTimeout(() => {
            if (this.dtFilterType == "all") {
                param.Condition = {
                    HisTypeId: this.HistoryType,
                    CandidateId: this.candidateId,
                    IsMatching: this.historyMatching
                };
            } else {
                param.Condition = {
                    FromDateCreated: this.dtDateRange ? DataHelper.formatDateFromDate(this.dtDateRange[0]) : null,
                    ToDateCreated: this.dtDateRange ? DataHelper.formatDateFromDate(this.dtDateRange[1]) : null,
                    CandidateId: this.candidateId,
                    IsMatching: this.historyMatching,
                    HisTypeId: this.HistoryType
                };
            }

            if(typeInfo !== undefined){
                param.Condition.Type = typeInfo.Type;
            }

            // param.PageSize = this.pageSize;
            if (this.$route && this.$route.meta && this.$route.meta.Mode) {
                param.Mode = this.$route.meta.Mode; // FIXME Detail (Generic), Preview (All) // WA-2199
            }
            param.IncludeUnits = this.dtIncludeUnits;

            if (this.dtIncludeUnits && this.dtUnitIds) {
                param.Ids = this.dtUnitIds;
            }

            if (this.isMatching) {
                param.Mode = this.matchingMode;
            }
            this.dtIsLoading = true;
            this.historyService.getListOfHistory(param, { id: param.Id, childId: null }).then(data => {
                const result = new HistoryResponse(data);
                if(data.HistoryTypeInfo && (this.allHistoryTypeInfo.length < data.HistoryTypeInfo.length)){
                    this.allHistoryTypeInfo = data.HistoryTypeInfo;
                }

                this.HistoryTypeInfo = data.HistoryTypeInfo;              
                this.source = result;
                this.originSource = result; // Check change for Prospect
                this.dtIsLoading = false;
                this.dtUnitIds = result.Ids;
            }).catch((err) => {
                this.dtIsLoading = false;
            })
        }, 400);
    }

    handleEdit(record) {
        this.$emit("edit", record);
    }
    handleDelete(record) {
        this.$confirm(this.$t('DELETEWARNINGMESSAGES').toString(), this.$t('CONFIRMATION').toString(), {
            confirmButtonText: this.$t('DELETE').toString(),
            cancelButtonText: this.$t('CANCEL').toString(),
            type: "error",
            confirmButtonClass: "el-button--danger",
        }).then(() => {
            this.dtIsLoading = true;
            this.historyService.deleteHistory({
                Id: record.RootId,
                HisDetailId: record.HisDetailId
            }).then(data => {
                this.fetchData();
                this.dtIsLoading = false;
            }).catch((err) => {
                this.dtIsLoading = false;
            });
        }).catch(() => {
            // CANCEL
        });
        
    }


    changeFilter(f) {
        if (f == this.dtFilterType) {
            return;
        }

        const preType = this.dtFilterType;

        this.dtFilterType = f;


        if (f == "custom") {
            this.dtDateRange = null;
            if (preType !== 'all') {
                this.fetchData({ ...this.vModel, ...{ PageIndex: 1 } });
            }
        } else {
            let now = DateHelper.addDays(new Date(), 1);
            if (f == "all") {
                this.dtDateRange = null;
            } else if (f == "week") {
                var sinceDate = DateHelper.getDayAgo(now, 7);
                this.dtDateRange = [sinceDate, now];
            } else if (f == "month") {
                var sinceDate = DateHelper.getDayAgo(now, 30);
                this.dtDateRange = [sinceDate, now];
            }
            this.fetchData({ ...this.vModel, ...{ PageIndex: 1 } });
        }
    }

    changePage(page) {
        this.fetchData({ ...this.vModel, ...{ PageIndex: page } });
    }

    handlePageSizeChange(size) {
        this.vModel.PageSize = size;
        this.fetchData({ ...this.vModel, ...{ PageIndex: 1 } });
    }

    changeCustom() {
        this.fetchData({ ...this.vModel, ...{ PageIndex: 1 } });
    }

    changeType() {
        this.fetchData({ ...this.vModel, ...{ PageIndex: 1 } });
    }

    get isProspect(): boolean {
        return this.vModel.Mode === HistoryConfigurations.TYPE_PROPERTY_PROSPECT;
    }

    get isRelation(): boolean {
        return this.vModel.Mode === HistoryConfigurations.TYPE_PROPERTY_RELATIONS;
    }

    beforeDestroy() {
        clearTimeout(this._fetchDataTimeout);
        this._fetchDataTimeout = null;
        this.dtFilterType = null;
        this.dtDateRange = null;
        this.dtFilterSearch = null;
        EventBus.$off(EVENT_BUS.HISTORY.UPDATE_HISTORY_LIST, () => {
            this.fetchData();
        });
        EventBus.$off(EVENT_BUS.HISTORY.REFRESH_HISTORY_UPDATE_DOCUMENT, (context) => {
            this.updateListHistories(context);
        });
    }
    destroyed() {
    }

    changeCandidate() {
        this.fetchData();
    }
}

export default HistoryTimeLineComponent;
